module.exports = __webpack_public_path__ + "static/media/one-hub.1757c0d3.svg";